<div>
  <!--begin::Profile Personal Information-->
  <div class="d-flex flex-row">
    <!--begin::Aside-->
    <div class="flex-row-auto w-250px w-xxl-300px" id="kt_profile_aside">
      <!--begin::Profile Card-->
      <div class="card card-custom card-stretch panel_1" *ngIf="contact?.id">
        <!--begin::Body-->
        <div class="card-body pt-4">
          <!--begin::User-->
          <div
            class="d-flex align-items-center"
            style="margin-bottom: 20px; justify-content: center"
          >
            <span class="symbol symbol-70 symbol-xxl-100 align-self-start align-self-xxl-center">
              <span>
                <div>
                  <div class="image-input image-input-outline image-input-changed">
                    <img
                      class="image-input-wrapper"
                      id="contact_profile"
                      src="{{ contactProfile }}"
                      style="width: 150px; height: 150px"
                    />
                    <label
                      *ngIf="!isViewMode"
                      class="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow dropdown-toggle dropdown-toggle-split"
                      data-action="change"
                      data-toggle="dropdown"
                      title=""
                      aria-expanded="false"
                      data-original-title="Change avatar"
                    >
                      <i class="fa fa-pen icon-sm text-muted"></i>
                    </label>
                    <span
                      *ngIf="contact.pre_signed_url?.url"
                      class="btn btn-xs btn-icon btn-circle btn-white btn-hover-text-primary btn-shadow magnify-icon"
                      data-action="zoom"
                      (click)="showContactPhoto(contact)"
                      matTooltip="Zoom in"
                    >
                      <i class="flaticon-search-magnifier-interface-symbol icon-nm text-muted"></i>
                    </span>
                    <div class="dropdown-menu dropdown-menu-sm dropdown-menu-left">
                      <a class="dropdown-item" (click)="updateProfile()"> Upload photo </a>
                      <a *ngIf="contact && contact.id" class="dropdown-item" (click)="viewFiles()">
                        Previous photos
                      </a>
                    </div>
                  </div>
                </div>
              </span>
            </span>
          </div>
          <!--end::User-->
          <div>
            <div>
              <div
                style="max-width: 240px; overflow: hidden; margin: auto; text-align: center"
                class="main-cont"
              >
                <p
                  class="font-weight-bolder text-dark-75 mb-0 title-one"
                  [innerText]="firstLine()"
                ></p>
                <p
                  [innerText]="secondLine()"
                  class="font-weight-bolder text-dark-75 mb-0 title-two"
                ></p>
                <a class="text-primary m-0">{{ contact ? contact.entity_type : '' }}</a>
              </div>
            </div>
          </div>
          <!--begin::Contact-->
          <div class="py-3" style="padding-left: 1.5rem">
            <div
              class="d-flex align-items-center justify-content-left mb-5"
              matTooltip="Cell Phone"
            >
              <span class="font-weight-bold mr-2">
                <i class="fas fa-mobile-alt icon-md" aria-hidden="true"></i
              ></span>
              <a class="text-muted text-hover-primary">{{
                contact ? (contact.cell_phone | mask : '(000) 000-0000') : ''
              }}</a>
            </div>
            <div
              class="d-flex align-items-center justify-content-left mb-5"
              [matTooltip]="contact.email"
            >
              <span class="font-weight-bold mr-2">
                <i class="fa flaticon2-black-back-closed-envelope-shape" aria-hidden="true"></i
              ></span>
              <a class="text-muted text-hover-primary ellipsis">{{ contact.email }}</a>
            </div>
            <div class="d-flex align-items-center justify-content-left mb-5">
              <span class="font-weight-bold mr-2">
                <i class="fa flaticon2-user" aria-hidden="true"></i
              ></span>
              <a
                matTooltip="Username - Go to registration session"
                class="text-muted text-hover-primary clickable"
                *ngIf="contactUsername && !loadUsername"
                (click)="goToLastSession(contact)"
                >{{ contactUsername }}</a
              >
              <a
                matTooltip="Send link for Identity verification"
                class="ks-font-size-xs ks-text-neutral text-hover-primary ks-font-weight-medium clickable"
                *ngIf="!contactUsername && !loadUsername"
                (click)="sendInvitation(contact?.id)"
                >Send link for Identity verification</a
              >
              <mat-spinner diameter="20" *ngIf="loadUsername"></mat-spinner>
            </div>
            <div class="d-flex align-items-center justify-content-left mb-5" matTooltip="PIN">
              <span class="font-weight-bold mr-2">
                <i class="fa flaticon-squares" aria-hidden="true"></i
              ></span>
              <a class="text-muted text-hover-primary">{{ contact?.pin_number }}</a>
            </div>
          </div>
          <!--end::Contact-->
        </div>
        <!--end::Body-->
      </div>
      <!--end::Profile Card-->
      <!--begin::Profile Card-->
      <div class="card card-custom card-stretch panel_2">
        <!--begin::Body-->
        <div class="card-body pt-4">
          <!--begin::Nav-->
          <div class="navi navi-bold navi-hover navi-active navi-link-rounded">
            <ng-container
              *ngFor="let tab of tabs"
              [ngTemplateOutlet]="navi_item"
              [ngTemplateOutletContext]="{ tab: tab }"
            ></ng-container>
            <ng-template #navi_item let-tab="tab">
              <div *ngxPermissionsOnly="tab.permission" class="navi-item mb-2 clickable">
                <a
                  class="navi-link py-4"
                  [ngClass]="{ active: tab.active }"
                  (click)="changeTab(tab.index)"
                >
                  <span class="navi-icon mr-2">
                    <i class="{{ tab.icon }}"></i>
                  </span>
                  <span class="navi-text font-size-lg">{{ tab.label }}</span>
                </a>
              </div>
            </ng-template>
          </div>
          <!--end::Nav-->
        </div>
        <!--end::Body-->
      </div>
      <!--end::Profile Card-->
    </div>
    <!--end::Aside-->
    <!--begin::Content-->
    <div class="flex-row-fluid" style="min-height: 1400px; margin-left: 8px">
      <!--begin::Card-->
      <div class="card card-custom card-stretch" *ngIf="tabs[0]?.active">
        <!--begin::Header-->
        <div class="card-header py-3">
          <div class="card-title align-items-start flex-column">
            <h3 class="card-label font-weight-bolder text-dark">
              {{
                contact?.id
                  ? (contact.first_name ? contact.first_name : '') +
                    ' ' +
                    (contact.middle_name ? contact.middle_name : '') +
                    ' ' +
                    (contact.last_name ? contact.last_name : '') +
                    ' ' +
                    (contact.last_name2 ? contact.last_name2 : '') +
                    '’s Contact Information'
                  : 'New Contact'
              }}
            </h3>
            <span class="text-muted font-weight-bold font-size-sm mt-1"
              >{{ contact?.id ? 'Update ' : 'Add ' }} contact information</span
            >
          </div>
          <div class="card-toolbar">
            <ng-template ngxPermissionsOnly="canMergeContact">
              <button
                *ngIf="contact?.id && !isViewMode"
                class="mr-2"
                mat-button
                matTooltip="Merge contacts"
                (click)="mergeContact()"
              >
                Merge
              </button>
            </ng-template>
            <a
              ktBackButton
              class="btn btn-secondary mr-2"
              mat-raised-button
              matTooltip="{{ 'AUTH.INPUT.BACK' | translate }}"
            >
              <i class="la la-arrow-left"></i>
              <span class="hidden-mobile"> {{ 'AUTH.INPUT.BACK' | translate }}</span>
            </a>
            <a
              *ngIf="!isViewMode && contact && !contact.id"
              class="btn btn-secondary mr-2"
              (click)="reset()"
              [disabled]="selectedTab !== 0"
              mat-raised-button
              matTooltip="Reset changes"
            >
              <i class="la la-cog"></i>
              <span class="hidden-mobile" translate="GLOBAL.RESET">Reset</span>
            </a>
            <ng-template ngxPermissionsOnly="canEditContact">
              <a
                *ngIf="isViewMode"
                (click)="editContact(contact.id)"
                class="btn btn-secondary mr-2"
                mat-raised-button
                matTooltip="Edit Contact"
              >
                <span class="hidden-mobile" translate="GLOBAL.EDIT">Edit</span>
              </a>
            </ng-template>
            <a
              *ngIf="!isViewMode"
              class="btn btn-primary mr-2"
              color="primary"
              (click)="onSubmit()"
              mat-raised-button
              matTooltip="Save & Continue"
            >
              <span class="hidden-mobile" translate="GLOBAL.SAVE">Save</span>
            </a>
          </div>
        </div>
        <!--end::Header-->

        <!--begin::Form-->
        <form class="form" [formGroup]="contactForm" *ngIf="loadingData">
          <kt-alert
            *ngIf="hasFormErrors"
            type="warn"
            [showCloseButton]="true"
            [duration]="10000"
            (closeAl)="onAlertClose()"
          >
            <span translate="GLOBAL.FORM_ERROR"
              >Oh snap! Change a few things up and try submitting again.</span
            >
          </kt-alert>
          <kt-alert
            *ngIf="hasSubmissionErrors && !hasFormErrors"
            type="warn"
            [duration]="30000"
            [showCloseButton]="true"
            (closeAl)="onAlertClose()"
          >
            <ul>
              <li *ngFor="let err of submissionErrorObj">{{ err.error | translate }}</li>
            </ul>
          </kt-alert>
          <input type="hidden" formControlName="entity_id" />

          <!--begin::Body-->
          <div class="card-body">
            <div class="row">
              <h5 class="font-weight-bold mb-6">Basic Info</h5>
            </div>
            <div class="form-group row">
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid" appearance="fill">
                  <mat-label>{{ 'PATIENT.INPUT.FIRST_NAME' | translate }}</mat-label>
                  <input
                    matInput
                    placeholder="Enter First Name"
                    formControlName="first_name"
                    autocomplete="kt-contact-first-name"
                    required
                  />
                  <mat-error
                    >{{ 'PATIENT.INPUT.FIRST_NAME' | translate }}
                    <strong>{{ 'PATIENT.VALIDATION.REQUIRED' | translate }}</strong>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid" appearance="fill">
                  <mat-label>{{ 'PATIENT.INPUT.MIDDLE_NAME' | translate }}</mat-label>
                  <input
                    matInput
                    placeholder="Enter Middle Name"
                    formControlName="middle_name"
                    autocomplete="kt-contact-middle-name"
                  />
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid" appearance="fill">
                  <mat-label>{{ 'PATIENT.INPUT.LAST_NAME' | translate }}</mat-label>
                  <input
                    matInput
                    placeholder="Enter Last Name"
                    formControlName="last_name"
                    autocomplete="kt-contact-last-name"
                    required
                  />
                  <mat-error
                    >{{ 'PATIENT.INPUT.LAST_NAME' | translate }}
                    <strong>{{ 'PATIENT.VALIDATION.REQUIRED' | translate }}</strong>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid" appearance="fill">
                  <mat-label>{{ 'PATIENT.INPUT.LAST_NAME_2' | translate }}</mat-label>
                  <input
                    matInput
                    placeholder="Enter Last Name 2"
                    formControlName="last_name2"
                    autocomplete="kt-contact-last-name-2"
                  />
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label>Nickname/AKA</mat-label>
                  <input matInput formControlName="nickname" autocomplete="kt-contact-nickname" />
                </mat-form-field>
              </div>

              <div class="col-lg-2 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label>Gender</mat-label>
                  <mat-select formControlName="gender">
                    <mat-option value="MALE">Male</mat-option>
                    <mat-option value="FEMALE">Female</mat-option>
                    <mat-option value="">Undefined</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div class="col-lg-2 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid" appearance="fill">
                  <mat-label>{{ 'PATIENT.INPUT.DOB' | translate }}</mat-label>
                  <input
                    matInput
                    [matDatepicker]="dob"
                    formControlName="dob"
                    [max]="maxDate"
                    ktDateMaskControl
                    maxlength="10"
                    placeholder="MM/DD/YYYY"
                    autocomplete="kt-contact-dob"
                    (dateChange)="setMaxDate($event)"
                  />
                  <mat-datepicker-toggle matSuffix [for]="dob"></mat-datepicker-toggle>
                  <mat-datepicker #dob></mat-datepicker>
                  <mat-error *ngIf="isControlHasError('dob', 'required')">
                    {{ 'PATIENT.INPUT.DOB' | translate }}
                    <strong>{{ 'PATIENT.VALIDATION.REQUIRED' | translate }}</strong>
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label translate="CONTACT.FORM.EMAIL">Email</mat-label>
                  <input
                    matInput
                    type="email"
                    formControlName="email"
                    autocomplete="kt-contact-email"
                  />
                  <mat-error *ngIf="isControlHasError('email', 'required')">
                    Email is
                    <strong>required</strong>
                  </mat-error>
                  <mat-error *ngIf="isControlHasError('email', 'email')">
                    Email is not valid
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label>Language Preference</mat-label>
                  <mat-select formControlName="language_preference">
                    <mat-option *ngFor="let lang of languages" [value]="lang.id">{{
                      lang.language
                    }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-lg-2 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label>PIN</mat-label>
                  <input
                    matInput
                    formControlName="pin_number"
                    maxlength="6"
                    minlength="4"
                    autocomplete="kt-contact-pin-number"
                  />
                  <mat-error *ngIf="isControlHasError('pin_number', 'pattern')">
                    <strong>PIN </strong> must be number
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-3 kt-margin-bottom-20-mobile">
                <div class="mat-form-field-fluid">
                  <mat-label class="row ml-1" translate="CONTACT.FORM.CONTACT_STATUS"
                    >Contact Status</mat-label
                  >
                  <mat-slide-toggle class="mr-2" formControlName="isActive"></mat-slide-toggle>
                  <mat-hint align="start">
                    <strong>{{ getStatusString() }}</strong>
                  </mat-hint>
                </div>
              </div>
            </div>
            <div class="row">
              <h5 class="font-weight-bold mb-6">Contacts</h5>
            </div>
            <div class="form-group row">
              <div class="col-lg-8 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label translate="CONTACT.FORM.CELLPHONE">Cell Phone</mat-label>
                  <input
                    matInput
                    type="tel"
                    formControlName="cell_phone"
                    maxlength="14"
                    ktAppPhoneMask
                    autocomplete="kt-contact-cellphone"
                  />
                  <mat-error *ngIf="isControlHasError('cell_phone', 'required')">
                    Cell Phone is
                    <strong>required</strong>
                  </mat-error>
                  <mat-error *ngIf="isControlHasError('cell_phone', 'pattern')">
                    Cell Phone is invalid
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-2 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid gl-block" appearance="fill">
                  <mat-label>Office Number</mat-label>
                  <input
                    matInput
                    type="tel"
                    maxlength="14"
                    placeholder="Enter Office Number"
                    ktAppPhoneMask
                    formControlName="office_number"
                    autocomplete="kt-patient-office-number"
                  />
                </mat-form-field>
              </div>
              <div class="col-lg-2 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid gl-block" appearance="fill">
                  <mat-label>Extension</mat-label>
                  <input
                    matInput
                    placeholder="Enter Extension"
                    maxlength="7"
                    formControlName="extension"
                    autocomplete="kt-patient-extension"
                  />
                  <mat-hint><strong>Must be less than 7 digit</strong></mat-hint>
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label>Phone 1</mat-label>
                  <input
                    matInput
                    type="tel"
                    formControlName="home_phone"
                    maxlength="14"
                    ktAppPhoneMask
                    autocomplete="kt-contact-home-phone"
                  />
                  <mat-error *ngIf="isControlHasError('home_phone', 'pattern')">
                    Phone1 is invalid
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label>Phone 2</mat-label>
                  <input
                    matInput
                    type="tel"
                    formControlName="phone2"
                    maxlength="14"
                    ktAppPhoneMask
                    autocomplete="kt-contact-phone-2"
                  />
                  <mat-error *ngIf="isControlHasError('phone2', 'pattern')">
                    Phone2 is invalid
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label translate="CONTACT.FORM.FAX">Fax</mat-label>
                  <input
                    matInput
                    type="tel"
                    formControlName="fax"
                    maxlength="14"
                    ktAppPhoneMask
                    autocomplete="kt-contact-fax"
                  />
                  <mat-error *ngIf="isControlHasError('fax', 'required')">
                    Fax is
                    <strong>required</strong>
                  </mat-error>
                  <mat-error *ngIf="isControlHasError('fax', 'pattern')">
                    Fax is invalid
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-12 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label>Preferred Times</mat-label>
                  <input
                    matInput
                    formControlName="preferred_time"
                    autocomplete="kt-contact-preferred-time"
                  />
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <h5 class="font-weight-bold mb-6">Address</h5>
            </div>
            <div class="form-group row">
              <div class="col-lg-12 kt-margin-bottom-20-mobile">
                <mat-form-field class="mat-form-field-fluid" appearance="fill">
                  <mat-label>{{ 'DOCTOR.INPUT.URBANIZATION' | translate }}</mat-label>
                  <input
                    matInput
                    formControlName="urbanization"
                    [ngModel]="urbanizationValue"
                    autocomplete="kt-contact-urbanization"
                    (ngModelChange)="urbanizationValue = $event ? $event.toUpperCase() : ''"
                  />
                  <mat-error *ngIf="isControlHasError('urbanization', 'maxlength')">
                    Maximum length is 48 character
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-12 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label translate="CONTACT.FORM.ADDRESS1">Address1</mat-label>
                  <input
                    matInput
                    formControlName="address1"
                    [ngModel]="Address1Value"
                    autocomplete="kt-contact-address-1"
                    (ngModelChange)="Address1Value = $event ? $event.toUpperCase() : ''"
                  />
                  <mat-error *ngIf="isControlHasError('address1', 'maxlength')">
                    Maximum length is 48 character
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-12 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label translate="CONTACT.FORM.ADDRESS2">Address2</mat-label>
                  <input
                    matInput
                    formControlName="address2"
                    [ngModel]="Address2Value"
                    autocomplete="kt-contact-address-2"
                    (ngModelChange)="Address2Value = $event ? $event.toUpperCase() : ''"
                  />
                  <mat-error *ngIf="isControlHasError('address2', 'maxlength')">
                    Maximum length is 48 character
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label translate="CONTACT.FORM.CITY">City</mat-label>
                  <input
                    matInput
                    formControlName="city"
                    [ngModel]="cityValue"
                    autocomplete="kt-contact-city"
                    (ngModelChange)="cityValue = $event ? $event.toUpperCase() : ''"
                  />
                  <mat-error *ngIf="isControlHasError('city', 'maxlength')">
                    Maximum length is 30 character
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label translate="CONTACT.FORM.STATE">State</mat-label>
                  <mat-select formControlName="state">
                    <mat-option value="AL">AL</mat-option>
                    <mat-option value="AK">AK</mat-option>
                    <mat-option value="AR">AR</mat-option>
                    <mat-option value="AZ">AZ</mat-option>
                    <mat-option value="CA">CA</mat-option>
                    <mat-option value="CO">CO</mat-option>
                    <mat-option value="CT">CT</mat-option>
                    <mat-option value="DC">DC</mat-option>
                    <mat-option value="DE">DE</mat-option>
                    <mat-option value="FL">FL</mat-option>
                    <mat-option value="GA">GA</mat-option>
                    <mat-option value="HI">HI</mat-option>
                    <mat-option value="IA">IA</mat-option>
                    <mat-option value="ID">ID</mat-option>
                    <mat-option value="IL">IL</mat-option>
                    <mat-option value="IN">IN</mat-option>
                    <mat-option value="KS">KS</mat-option>
                    <mat-option value="KY">KY</mat-option>
                    <mat-option value="LA">LA</mat-option>
                    <mat-option value="MA">MA</mat-option>
                    <mat-option value="MD">MD</mat-option>
                    <mat-option value="ME">ME</mat-option>
                    <mat-option value="MI">MI</mat-option>
                    <mat-option value="MN">MN</mat-option>
                    <mat-option value="MO">MO</mat-option>
                    <mat-option value="MS">MS</mat-option>
                    <mat-option value="MT">MT</mat-option>
                    <mat-option value="NC">NC</mat-option>
                    <mat-option value="NE">NE</mat-option>
                    <mat-option value="NH">NH</mat-option>
                    <mat-option value="NJ">NJ</mat-option>
                    <mat-option value="NM">NM</mat-option>
                    <mat-option value="NV">NV</mat-option>
                    <mat-option value="NY">NY</mat-option>
                    <mat-option value="ND">ND</mat-option>
                    <mat-option value="OH">OH</mat-option>
                    <mat-option value="OK">OK</mat-option>
                    <mat-option value="OR">OR</mat-option>
                    <mat-option value="PA">PA</mat-option>
                    <mat-option value="PR">PR</mat-option>
                    <mat-option value="RI">RI</mat-option>
                    <mat-option value="SC">SC</mat-option>
                    <mat-option value="SD">SD</mat-option>
                    <mat-option value="TN">TN</mat-option>
                    <mat-option value="TX">TX</mat-option>
                    <mat-option value="UT">UT</mat-option>
                    <mat-option value="VT">VT</mat-option>
                    <mat-option value="VA">VA</mat-option>
                    <mat-option value="WA">WA</mat-option>
                    <mat-option value="WI">WI</mat-option>
                    <mat-option value="WV">WV</mat-option>
                    <mat-option value="WY">WY</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div class="col-lg-4 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label translate="CONTACT.FORM.ZIP">Zip</mat-label>
                  <input
                    matInput
                    formControlName="zip"
                    maxlength="10"
                    [ngModel]="zipValue"
                    autocomplete="kt-contact-zip-code"
                    (ngModelChange)="zipValue = $event ? putDash($event) : ''"
                  />
                  <mat-error *ngIf="isControlHasError('zip', 'pattern')">
                    Zip Code is invalid
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <h5 class="font-weight-bold mb-6">Other</h5>
            </div>
            <div class="form-group row">
              <div class="col-lg-12 kt-margin-bottom-20-mobile">
                <mat-form-field appearance="fill" class="mat-form-field-fluid">
                  <mat-label translate="CONTACT.FORM.NOTE">Note</mat-label>
                  <textarea
                    matInput
                    rows="7"
                    formControlName="note"
                    maxlength="10000"
                    autocomplete="kt-contact-note"
                  ></textarea>
                  <mat-hint align="end">{{ contactForm.get('note').value?.length || 0 }}/10000</mat-hint>
                  <mat-error *ngIf="isControlHasError('note', 'maxlength')">
                    Maximum length is 10000 characters
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
            <div class="row">
              <h5 class="font-weight-bold mb-6">Tags</h5>
            </div>
            <div class="form-group row">
              <div class="col-lg-12 kt-margin-bottom-20-mobile">
                <kt-tags
                  [autocompleteEntity]="'CONTACT'"
                  [controlObject]="tags"
                  [appearance]="'fill'"
                  [value]="tags$"
                  category="Entity"
                ></kt-tags>
              </div>
            </div>
          </div>
          <!--end::Body-->
        </form>
        <!--end::Form-->
      </div>
      <!--begin::Card-->
      <div class="card card-custom card-stretch" *ngIf="tabs[1]?.active">
        <div class="until-they">
          <mat-tab-group>
            <mat-tab>
              <ng-template mat-tab-label>Entity Relations</ng-template>
              <ng-template matTabContent>
                <div class="until-they">
                  <kt-relationships-list [contact]="contact"></kt-relationships-list>
                </div>
              </ng-template>
            </mat-tab>
            <mat-tab *ngIf="displayAffiliation">
              <ng-template mat-tab-label>Affiliation Relations</ng-template>
              <ng-template matTabContent>
                <div class="until-they">
                  <!--                  [isViewMode]="isViewMode" add this in the last copy -->
                  <kt-affiliation-relation-list
                    [entityType]="'CONTACT'"
                  ></kt-affiliation-relation-list>
                </div>
              </ng-template>
            </mat-tab>
          </mat-tab-group>
        </div>
      </div>
      <!--begin::Card-->
      <div class="card card-custom card-stretch" *ngIf="tabs[2]?.active">
        <div class="until-they">
          <kt-note-list
            [entityId]="contact?.id"
            [entityType]="NoteEntityType.CONTACT"
          ></kt-note-list>
        </div>
      </div>

      <!--begin::Card-->
      <div class="card card-custom card-stretch" *ngIf="tabs[3]?.active && contact">
        <kt-bridgepay-wallet
          [customerId]="getCustomerID(contact)"
          [organization]="companyUUID"
        ></kt-bridgepay-wallet>
      </div>

      <div class="card card-custom card-stretch" *ngIf="tabs[4]?.active">
        <div class="until-they">
          <kt-contact-hitory-tab></kt-contact-hitory-tab>
        </div>
      </div>

      <!--begin::Card-->
      <div class="card card-custom card-stretch" *ngIf="tabs[5]?.active">
        <div class="until-they">
          <kt-contact-login
            [result]="historyResult"
            (username)="showUsername($event)"
          ></kt-contact-login>
        </div>
      </div>

      <!--begin::Card-->
      <div class="card card-custom card-stretch" *ngIf="tabs[6]?.active">
        <div class="until-they">
          <kt-contact-history
            [result]="historyResult"
            (username)="showUsername($event)"
          ></kt-contact-history>
        </div>
      </div>

      <!--begin::Card-->
      <div class="card card-custom card-stretch" *ngIf="tabs[7]?.active">
        <div class="until-they">
          <kt-portlet>
            <kt-portlet-header [class]="'card-head-lg'">
              <ng-container ktPortletTitle>
                <span>Analytics</span>
              </ng-container>
            </kt-portlet-header>
            <kt-portlet-body>
              <div *ngIf="role" class="row ml-2">
                <label>Rule: {{ role | titlecase }}</label>
              </div>
              <div class="row ml-4"></div>
              <div class="row ml-2">
                <label>Apps:</label>
              </div>
              <div class="ml-3" *ngIf="data?.length === 0"><strong> No Access </strong></div>
              <ul *ngFor="let app of data">
                <li>
                  {{ app.name }}
                  <ul *ngFor="let pageGroup of app.page_groups">
                    <li>
                      {{ pageGroup.name }}
                      <ul *ngFor="let page of pageGroup.pages">
                        <li>{{ page.name }}</li>
                      </ul>
                    </li>
                  </ul>
                </li>
              </ul>
            </kt-portlet-body>
          </kt-portlet>
        </div>
      </div>
      <!--end::Content-->
    </div>
    <!--end::Profile Personal Information-->
  </div>
</div>
